import { track } from './index';
const campaignPayload = (campaign) => ({
    campaignId: campaign.campaignId,
    status: campaign.status,
    campaignName: campaign.name,
    message: campaign.message,
    sentDate: campaign.sentDate,
    audienceCount: campaign.total,
});
export const CONTEXT = {
    SMS_LIST: 'sms-campaigns-list',
    SMS_CREATE: 'sms-campaigns-create',
};
export const mixpanelSmsCampaign = {
    inactivateClick: (campaign) => track(`${CONTEXT.SMS_LIST}_clicked_inactivate-campaign-table`, {
        ...campaignPayload(campaign),
    }),
    inactivateCancel: (campaign) => track(`${CONTEXT.SMS_LIST}_modal_clicked_inactivate-btn-cancel`, {
        ...campaignPayload(campaign),
    }),
    inactivateConfirm: (campaign) => track(`${CONTEXT.SMS_LIST}_modal_clicked_inactivate-btn-confirm`, {
        ...campaignPayload(campaign),
    }),
    redirectCreateCampaign: () => track(`${CONTEXT.SMS_LIST}_clicked_btn-create-campaign`),
    listSmsPageViewed: () => track(`${CONTEXT.SMS_LIST}_viewed`),
    errorInactiveCampaign: () => track(`${CONTEXT.SMS_LIST}_clicked_error-inactive`),
    create: (campaign) => track(`${CONTEXT.SMS_CREATE}_clicked_btn-create-campaign`, {
        campaignName: campaign.campaignName,
        message: campaign.message,
        sentDate: campaign.sentDate,
        audienceId: campaign.audienceId,
    }),
    sendSmsTest: (message, phone) => track(`${CONTEXT.SMS_CREATE}_modal-sms-test_clicked_btn-send`, {
        message,
        phone,
    }),
    messagePreview: (message) => track(`${CONTEXT.SMS_CREATE}_modal-message_clicked_link-preview`, {
        message,
    }),
    invalidCharacters: (message) => track(`${CONTEXT.SMS_CREATE}_modal-message_viewed_invalid-characters`, {
        message,
    }),
    saveMessage: (message) => track(`${CONTEXT.SMS_CREATE}_modal-message_clicked_btn-save`, {
        message,
    }),
    buySms: (context) => track(`${context === 'list' ? CONTEXT.SMS_LIST : CONTEXT.SMS_CREATE}_clicked_link-redirect-buy-sms`, {
        context,
    }),
    createSmsPageViewed: () => track(`${CONTEXT.SMS_CREATE}_viewed`),
    modalSmsViewed: () => track(`${CONTEXT.SMS_CREATE}_viewed_modal-message`),
    createAudience: () => track(`${CONTEXT.SMS_CREATE}_clicked_link-redirect-audiences`),
    errorPeriodInThePast: () => track(`${CONTEXT.SMS_CREATE}_error-period-in-the-past`),
};
